import { getCustomerId } from '@helpers/visitor';

/**
 * Track impression
 * @param {array} data
 * @param {function} tracker
 */
// eslint-disable-next-line import/prefer-default-export
export const trackImpression = (data, tracker) => {
    const { store, language } = App.Config;
    const context = [
        {
            schema: 'iglu:com.boozt/boozt_page_context/jsonschema/1-0-0',
            data: {
                store,
                language,
                customer_id: getCustomerId().toString()
            }
        }
    ];

    tracker(...data);
    tracker('trackEnhancedEcommerceAction', 'view', context);
};

export const formatPrice = (price) => {
    if (price?.includes('.')) {
        return price.split('.').join('');
    }

    return price;
};
